import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {BackupService} from "../../../services/backup.service";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {ViewMode} from "../../interfaces";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-department-detail',
    templateUrl: './department-detail.component.html',
    imports: [
        NgIf,
        ReactiveFormsModule
    ],
    styleUrl: './department-detail.component.scss'
})
export class DepartmentDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_department!: string;
    viewMode!: ViewMode;
    department: any;

    ngOnInit(): void {
        this.id_department = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_department == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            name: [null, Validators.required],
        });

        if (this.id_department !== '0') {
            this.getDepartment();
        }
    }

    getDepartment(): void {
        this.dataService.request('Department/get', {
            id_department: this.id_department
        }).subscribe(response => {
            this.department = response.department;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.department.id,
            name: this.department.name,
        });
    }

    save(): void {
        this.dataService.request('Department/save', {
            department: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/department']);
            this.toastrService.success('Die Abteilung wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Department/update', {
            department: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getDepartment();
            this.toastrService.success('Die Abteilung wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/department']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getDepartment();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Die Abteilung wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Department/delete', {
                    id_department: this.id_department
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Die Abteilung wurde gelöscht');
                });
            }
        });
    }

}
